import { render, staticRenderFns } from "./CatalogStories.vue?vue&type=template&id=0bc2134e&scoped=true"
import script from "./CatalogStories.vue?vue&type=script&lang=js"
export * from "./CatalogStories.vue?vue&type=script&lang=js"
import style0 from "./CatalogStories.vue?vue&type=style&index=0&id=0bc2134e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2134e",
  null
  
)

export default component.exports